import { IUtilitiesTerms } from '../../../../types/offer';

export function getFlowMetersInfo(terms: IUtilitiesTerms) {
  if (terms.flowMetersNotIncludedInPrice === false) {
    return '(счётчики включены)';
  }

  return '(без счётчиков)';
}
